import { FEATURES } from "../../../../../../config/features"

export const PassportSeamanBookTab = ({
  passport,
  setPassport,
  passportIssueDate,
  setPassportIssueDate,
  passportExpiryDate,
  setPassportExpiryDate,
  seamansBookNumber,
  setSeamansBookNumber,
  seamansBookIssueDate,
  setSeamansBookIssueDate,
  seamansBookExpiryDate,
  setSeamansBookExpiryDate,

  isEditMode,
  showSeamanBook
}) => {
  return (
    <div className="accounts-tab column mt-3">

      {/* Passport Section */}
      <div className="passport-details rounded-md p-2">
        <h4
          className="text-customMainColor"
          style={{ marginBottom: "0" }}
        >
          Passport Details
        </h4>
        <div className="accounts-tab-itemHolder info-item-holder row p-2">
          <div className="info-item info-item3 column">
            <div className="info-item-label">Passport Number</div>
            <div className="info-item-input">
              <input id="AddEmployee-PassportNumber" placeholder="Passport Number"
                readOnly={!isEditMode} value={passport} onChange={(e) => setPassport(e.target.value)}
              />
            </div>
          </div>
          <div className="info-item info-item3 column">
            <div className="info-item-label">Passport Issue Date</div>
            <div className="info-item-input">
              <input type="date"
                readOnly={!isEditMode} value={passportIssueDate} onChange={(e) => setPassportIssueDate(e.target.value)}
              />
            </div>
          </div>
          <div className="info-item info-item3 column">
            <div className="info-item-label">Passport Expiry Date</div>
            <div className="info-item-input">
              <input type="date"
                readOnly={!isEditMode} value={passportExpiryDate} onChange={(e) => setPassportExpiryDate(e.target.value)}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Seaman's Book Section */}
      {FEATURES.EMPLOYEE_ACCOUNT_SEAMAN_BOOK && (
        <div className="seamans-book-details rounded-md p-2">
          <h4
            className="text-customMainColor"
            style={{ marginBottom: "0" }}
          >
            Seaman’s Book Details
          </h4>

          <div className="accounts-tab-itemHolder info-item-holder row p-2">
            <div className="info-item info-item3 column">
              <div className="info-item-label">Seaman’s Book No</div>
              <div className="info-item-input">
                <input placeholder="Seaman’s Book No"
                  readOnly={!isEditMode} value={seamansBookNumber} onChange={(e) => setSeamansBookNumber(e.target.value)}
                />
              </div>
            </div>
            <div className="info-item info-item3 column">
              <div className="info-item-label">Book Issue Date</div>
              <div className="info-item-input">
                <input type="date"
                  readOnly={!isEditMode} value={seamansBookIssueDate} onChange={(e) => setSeamansBookIssueDate(e.target.value)}
                />
              </div>
            </div>
            <div className="info-item info-item3 column">
              <div className="info-item-label">Book Expiry Date</div>
              <div className="info-item-input">
                <input type="date"
                  readOnly={!isEditMode} value={seamansBookExpiryDate} onChange={(e) => setSeamansBookExpiryDate(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  )
}